import { ModuleSize } from '@movecloser/page-builder/lib/contracts'

import { ModuleBase, ModuleFactory } from '../../contexts'

import { abstractModuleFactory, getDefaultModuleAlignment } from '../abstract/form'
import { AvailableModuleDriver } from '../allowed'
import {
  ProductApplicationSliderModule,
  ProductApplicationSliderModuleContent
} from './ProductApplicationSlider.contracts'

export const productApplicationSliderContentFactory = (): ProductApplicationSliderModuleContent => ({
  content: '__PRODUCT[sku]__',
  align: undefined,
  alignDesktop: undefined,
  level: 1,
  text: '',
})

export const productApplicationSliderFactory: ModuleFactory<ProductApplicationSliderModule> = {
  ...abstractModuleFactory,
  createInitialSize (): ModuleSize {
    return {
      colSpan: 12,
      isResizable: false,
      rowSpan: 3
    }
  },
  createModule (): ModuleBase<ProductApplicationSliderModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: productApplicationSliderContentFactory(),
      driver: AvailableModuleDriver.ProductApplicationSlider
    }
  }
}
